import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { paymentFormDefault } from "@factory/form/form.default";
import { PaymentFormRule, PaymentFormSchema } from "@factory/form/form.rule";
import { useQyCreatePayment } from "@factory/query/payment.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewPayment() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePayment } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Payment is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPayment, isLoading: isCreating } =
    useQyCreatePayment(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PaymentFormSchema>({
    defaultValues: paymentFormDefault,
    resolver: zodResolver(PaymentFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PaymentFormSchema) => {
    const formData = mapCreatePayment(form);
    addPayment(formData);
  };
  const handleValidateError = (err: FieldErrors<PaymentFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
